import React from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

export const useGoTo = () => {
  const history = useHistory();
  return (url) => {
    if (!url) return;
    history.push(url);
  };
};

export const WidgetRow = ({ icon, tone = 'neutral', title, subtitle, right, onClick }) => (
  <div
    className={`mydesk-row ${onClick ? 'is-clickable' : ''}`}
    role={onClick ? 'button' : undefined}
    tabIndex={onClick ? 0 : undefined}
    onClick={onClick}
    onKeyDown={onClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } } : undefined}
  >
    {icon && (
      <span className={`mydesk-row-icon tone-${tone}`}>
        <FontAwesomeIcon icon={icon} />
      </span>
    )}
    <span className="mydesk-row-main">
      <span className="mydesk-row-title">{title}</span>
      {subtitle && <span className="mydesk-row-sub">{subtitle}</span>}
    </span>
    {right}
    {onClick && <FontAwesomeIcon icon={faChevronRight} className="mydesk-row-chev" />}
  </div>
);

export const WidgetFooter = ({ label, url }) => {
  const goTo = useGoTo();
  if (!url) return null;
  return (
    <button type="button" className="mydesk-foot" onClick={() => goTo(url)}>
      {label}
      <FontAwesomeIcon icon={faChevronRight} />
    </button>
  );
};

export const WidgetEmpty = ({ children }) => (
  <div className="mydesk-empty-state">{children}</div>
);

export const Pill = ({ tone = 'neutral', children }) => (
  <span className={`mydesk-pill tone-${tone}`}>{children}</span>
);

export const Age = ({ children }) => <span className="mydesk-age">{children}</span>;

export const formatMoney = (amount, currency) => {
  if (amount === null || amount === undefined || amount === '') return '';
  const n = Number(amount);
  if (Number.isNaN(n)) return `${currency || ''} ${amount}`.trim();
  return `${currency || ''} ${n.toLocaleString('en-GB', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`.trim();
};

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const parseISODate = (value) => {
  if (!value) return null;
  const [y, m, d] = String(value).slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
};

export const formatShortDate = (value) => {
  const dt = parseISODate(value);
  if (!dt) return '';
  return `${dt.getDate()} ${MONTHS[dt.getMonth()]}`;
};

export const formatRange = (start, end) => {
  if (!start) return '';
  if (!end || end === start) return formatShortDate(start);
  return `${formatShortDate(start)} to ${formatShortDate(end)}`;
};
